import { render, staticRenderFns } from "./ServiceTypesCategoriesRegistryEditForm.vue?vue&type=template&id=e940ee00"
import script from "./ServiceTypesCategoriesRegistryEditForm.vue?vue&type=script&lang=js"
export * from "./ServiceTypesCategoriesRegistryEditForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports